var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 16.3066H23.76C22.4533 16.3066 21.2933 17.0266 20.7066 18.2L19.5866 20.4133C19.32 20.9466 18.7866 21.28 18.2 21.28H13.8266C13.4133 21.28 12.8266 21.1866 12.44 20.4133L11.32 18.2133C10.7333 17.0533 9.55996 16.32 8.26663 16.32H3.59996C3.07996 16.32 2.66663 16.7333 2.66663 17.2533V21.6C2.66663 26.44 5.57329 29.3333 10.4266 29.3333H21.6C26.1733 29.3333 28.9866 26.8266 29.3333 22.3733V17.24C29.3333 16.7333 28.92 16.3066 28.4 16.3066Z",
    fill: "url(#paint0_linear_1695_34893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.07999L17.96 6.03999C18.16 6.23999 18.4133 6.33332 18.6666 6.33332C18.92 6.33332 19.1733 6.23999 19.3733 6.03999C19.76 5.65332 19.76 5.01332 19.3733 4.62665L16.7066 1.95999C16.6933 1.94665 16.68 1.94665 16.68 1.93332C16.6 1.85332 16.4933 1.78665 16.3866 1.73332C16.3733 1.73332 16.3733 1.73332 16.36 1.71999C16.2533 1.67999 16.1466 1.66665 16.04 1.65332C16 1.65332 15.9733 1.65332 15.9333 1.65332C15.8533 1.65332 15.7733 1.67999 15.6933 1.70665C15.6533 1.71999 15.6266 1.73332 15.6 1.74665C15.4933 1.79999 15.3866 1.85332 15.3066 1.94665L12.64 4.61332C12.2533 4.99999 12.2533 5.63999 12.64 6.02665C13.0266 6.41332 13.6666 6.41332 14.0533 6.02665L15.0133 5.06665V6.66665H17.0133V5.07999H17Z",
    fill: "url(#paint1_linear_1695_34893)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 14.4137V14.467C29.04 14.3603 28.72 14.307 28.4 14.307H23.76C21.6933 14.307 19.84 15.4537 18.92 17.2937L17.92 19.267H14.1066L13.1066 17.307C12.1866 15.4537 10.3333 14.307 8.26663 14.307H3.59996C3.27996 14.307 2.95996 14.3603 2.66663 14.467V14.4137C2.66663 9.56033 5.55996 6.66699 10.4133 6.66699H15V12.0003C15 12.547 15.4533 13.0003 16 13.0003C16.5466 13.0003 17 12.547 17 12.0003V6.66699H21.5866C26.44 6.66699 29.3333 9.56033 29.3333 14.4137Z",
    fill: "url(#paint2_linear_1695_34893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1695_34893",
    x1: 16,
    y1: 16.3066,
    x2: 16,
    y2: 29.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#379CFB",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046BCB",
    stopOpacity: 0.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1695_34893",
    x1: 16.0066,
    y1: 1.65332,
    x2: 16.0066,
    y2: 6.66665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#379CFB",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046BCB",
    stopOpacity: 0.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1695_34893",
    x1: 16,
    y1: 6.66699,
    x2: 16,
    y2: 19.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#379CFB",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046BCB",
    stopOpacity: 0.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/submitted.0df03b4b79b6c545a51034c66464d5d1.svg";
export { ForwardRef as ReactComponent };